<template>
  <router-view/>
</template>

<script>
import placesInGoals from 'store/placesInGoals.store';
import address from 'store/address.store';
import channel from 'store/channel.store';
import visit from 'store/visit.store';
import view from 'store/view.store';
import distributor from 'store/distributors.store';
import visitNextDay from 'store/visitNextDay';

const PLACE_IN_GOALS_STORE = 'placesInGoals';
const ADDRESS_STORE = 'address';
const CHANNEL_STORE = 'channel';
const VISIT_STORE = 'visit';
const VIEW_STORE = 'view';
const VIEW_DISTRIBUTOR = 'distributors';
const VISIT_NEXT_STORE = 'visitNextDay';

export default {
  beforeCreate() {
    this.$store.registerModule(PLACE_IN_GOALS_STORE, placesInGoals);
    this.$store.registerModule(ADDRESS_STORE, address);
    this.$store.registerModule(CHANNEL_STORE, channel);
    this.$store.registerModule(VISIT_STORE, visit);
    this.$store.registerModule(VIEW_STORE, view);
    this.$store.registerModule(VIEW_DISTRIBUTOR, distributor);
    this.$store.registerModule(VISIT_NEXT_STORE, visitNextDay);
  },
  beforeDestroy() {
    this.$store.unregisterModule(PLACE_IN_GOALS_STORE);
    this.$store.unregisterModule(ADDRESS_STORE);
    this.$store.unregisterModule(CHANNEL_STORE);
    this.$store.unregisterModule(VISIT_STORE);
    this.$store.unregisterModule(VISIT_NEXT_STORE);
    this.$store.unregisterModule(VIEW_DISTRIBUTOR);
    this.$store.unregisterModule(VIEW_STORE);
  }
};
</script>

<style scoped>
</style>
